/** GraphQL selection for reservation source type dropdowns (the fields any signed-in user may read). */
export const RESERVATION_SOURCE_TYPE_DROPDOWN_QUERY = `
  id
  name
  code
  enabled
`;
